import Api from "./Api";
import Csrf from "./Csrf";

export default {
  async index(serverParams) {
    await Csrf.getCookie();

    return Api.post("/daily-tasks/list", serverParams);
  },

  async update(id, form) {
    await Csrf.getCookie();

    return Api.patch("/daily-tasks/" + id, form);
  },

  async add(form) {
    await Csrf.getCookie();

    return Api.post("/daily-tasks", form);
  },

  async delete(id) {
    await Csrf.getCookie();

    return Api.delete("/daily-tasks/" + id);      
      
  },

  async getAvailableTasks() {
    await Csrf.getCookie();

    return Api.get("/daily-tasks/available-tasks");      
      
  },
 
};
